import { ScriptHackComponent } from './script-hack.component';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { HttpModule } from '@angular/http';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from '../../../app-routing.module';
import { NgModule } from '@angular/core';

@NgModule({
    declarations: [
        ScriptHackComponent
    ],
    imports: [
        BrowserModule,
        CommonModule,
        HttpModule,
        HttpClientModule,
        AppRoutingModule,
    ],
    providers: [],
    bootstrap: [],
    exports: [
        ScriptHackComponent
    ]
})
export class ScriptHackModule {}



// WEBPACK FOOTER //
// /codebuild/output/src727013012/src/src/app/shared/components/script-hack/script-hack.module.ts